/**
 * @desc 获取暂存区
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stagingAreaMaster.getStagingArea.Params, options?: any) {
  return updateResponse(
    http(URL + `/stagingAreaMaster/getStagingArea`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
